import { render, staticRenderFns } from "./InlineItemsList.vue?vue&type=template&id=c1422648&scoped=true&"
import script from "./InlineItemsList.vue?vue&type=script&lang=ts&"
export * from "./InlineItemsList.vue?vue&type=script&lang=ts&"
import style0 from "./InlineItemsList.vue?vue&type=style&index=0&id=c1422648&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1422648",
  null
  
)

export default component.exports